import { Injectable } from '@angular/core';
import {Contracts, ContractsInstallment} from '../db/contracts';
import {WSService} from 'projects/core/src/include/service'
import { Observable } from 'rxjs';
import { Globals } from 'projects/core/src/globals';
import { Filter, FilterAdvanced, Ordering } from 'projects/core/src/include/structures';
import { SignatureComponent } from '../modules/signature/signature.component';
import { TemplatesService } from 'projects/core/src/lib/templates.service';

@Injectable({
  providedIn: 'root'
})

export class ContractsService extends WSService<Contracts> {


  model:any;

  constructor(private templateService:TemplatesService) {super("contracts") }


  save(item: Contracts, return_id: Function, checkdeadlinesandactions?: boolean, showAfterMessage?: boolean): void {
      //verifica che il contratto è stato firmato o meno
     
      if(!item.signature || String(item.signature)=="0"){
        Globals.modal.showConfirm("Firma contratto","Il contratto non risulta firmato.",()=>{
          
            this.signatureContract(item);

          
        },"Si. Firmalo ora","No. Non Firmarlo");

      }

      super.save(item,return_id,checkdeadlinesandactions,showAfterMessage);
  }


  signatureContract(item:Contracts,openNewTab=true,callback=null){
    Globals.modal.showModal(SignatureComponent,[],(instance)=>{
            
      if(instance){
          item.signature="1";
          item.signature_file=instance.signature_file;
          item.signature_date=new Date().toMysqlDateTime();
          item.signature_user=Globals.user.id;

        
          this.save(item,()=>{
            if(this.model){
              this.model.exportInRow(item,openNewTab,()=>{
                if(callback){
                  callback(item);
                }
              })
              
            }
            /*
            //effettua la stampa contratto
            Globals.setLoading(true);
            this.templateService.openTemplate(results[0].id,JSON.stringify(m),"true","",results[0]['version']).subscribe((url)=>{
            Globals.setLoading(false);
            window.open(url,"_blank");
            
          });*/


          });
      }
    })
  }

  getTotals(filters:Filter[],ordering:Ordering[],advancedFilter:FilterAdvanced[]):Observable<any>{
    return Globals.ws.requestUrl("contracts","getTotals",this.getSQLWhere(filters,ordering,advancedFilter));
  }

  generateInstallments(start,end,amount,tax,amount_type,type,typedetail,id_contract,id_address,description,params=null):Observable<ContractsInstallment[]>{
    return Globals.ws.requestUrl("contracts","generateInstallments",[start,end,amount,tax,amount_type,type,typedetail,id_contract,id_address,description,params]);
  }

  setArchivedInstallments(id):Observable<any>{
    return Globals.ws.requestUrl("contracts","setArchivedInstallments",[id]);
  
  }


  setModel(model:any){
    this.model=model;
  }

}

